const WEIGHT_LABELS = {
  100: 'Thin',
  200: 'Extra Light',
  300: 'Light',
  400: 'Normal',
  500: 'Medium',
  600: 'Semi Bold',
  700: 'Bold',
  800: 'Extra Bold',
  900: 'Black',
  950: 'Extra Black',
};

// Weight breakpoints for normalization
const WEIGHT_BREAKPOINTS = [100, 200, 300, 400, 500, 600, 700, 800, 900, 950];

/**
 * Normalizes a font weight to the nearest standard weight category
 * @param weight The weight value to normalize
 * @returns The normalized weight value and label
 */
export const normalizeFontWeight = (weight: number) => {
  // Find the closest standard weight
  let closestWeight = WEIGHT_BREAKPOINTS[0];
  let minDifference = Math.abs(weight - closestWeight);

  for (const breakpoint of WEIGHT_BREAKPOINTS) {
    const difference = Math.abs(weight - breakpoint);
    if (difference < minDifference) {
      minDifference = difference;
      closestWeight = breakpoint;
    }
  }

  return {
    normalizedWeight: closestWeight,
    label: WEIGHT_LABELS[closestWeight as keyof typeof WEIGHT_LABELS],
  };
};
